import coverImg from "assets/images/v129/cover.webp"
import titleImg from "assets/images/v129/title.webp"
import bottomImg from "assets/images/v129/bottom.webp"

import titleDe from "assets/images/v129/title-de.webp"
import titleEs from "assets/images/v129/title-es.webp"
import titleFr from "assets/images/v129/title-fr.webp"
import titleIt from "assets/images/v129/title-it.webp"
import titleNl from "assets/images/v129/title-nl.webp"

export const v129Config = {
  cover: {
    en: coverImg,
    de: coverImg,
    es: coverImg,
    fr: coverImg,
    it: coverImg,
    nl: coverImg,
  },
  title: {
    en: titleImg,
    de: titleDe,
    es: titleEs,
    fr: titleFr,
    it: titleIt,
    nl: titleNl,
  },
  bottom: {
    en: bottomImg,
    de: bottomImg,
    es: bottomImg,
    fr: bottomImg,
    it: bottomImg,
    nl: bottomImg,
  },
}
